export const getVar = (name, defaultValue = null) => {
  if (typeof window !== 'undefined') {
    return window.env[name] || defaultValue;
  } else if (process.env[name]) {
    return process.env[name];
  }
  return defaultValue;
};
